export default {
  backgroundColor: '#f3f7fa',
  headerBackgroundColor: '#064367',
  headerColor: 'rgba(249, 252, 255, 0.8)',
  headerColorActive: '#fff',
  headerFocusColor: 'rgba(249, 252, 255, 0.15)',
  sidebarBackgroundColor: '#fefefe',
  sidebarColor: '#444d4d',
  sidebarColorActive: '#203641',
  sidebarDarkMode: false,
  sidebarHeaderBackgroundColor: '#064367',
  sidebarHeaderColor: 'rgba(249, 252, 255, 0.8)',
  sidebarHeaderColorActive: '#fff',
  sidebarInnerBackgroundColor: '#ecf2f6',
  sidebarInnerColor: '#444d4d',
  sidebarInnerColorActive: '#203641'
};
